import {
  PREDICTION_HISTOGRAM_DRAW_BAR,
  PREDICTION_HISTOGRAM_DRAW_PAINT,
  HISTOGRAM_CHART,
  SCATTERPLOT_CHART,
  PREDICTION,
  LINE_CHART,
  PARALLEL_COORDINATES_CHART,
  BAR_CHART,
  ACTUAL,
  SEEDATA,
  COMBINED,
  COMBINEDSTACKEDBARCHART,
  COMBINEDGROUPBARCHART,
  PREDICTION_HISTOGRAM_CANVAS_CLEAR,
  PREDICTION_HISTOGRAM_CANVAS_PENCIL
} from "../../Canvas/Constants";
import {
  histogramPredictionDataset,
  HistogramPrediction,
  brushingDataset,
  BrushingDataSet,
  BrushingPointsHistogram
} from "../../../Globals/Globals";
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import * as React from "react";
import { extent as d3ArrayExtent, histogram, range as d3Range } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
  scaleLinear as d3ScaleLinear,
  scalePoint as d3ScalePoint,
  scaleOrdinal as d3ScaleOrdinal
} from "d3-scale";
import {
  brush as d3brush,
  select as d3select,
  brushSelection as d3brushSelection
} from "d3";
import * as d3 from "d3";

import { schemeCategory10 as d3SchemeCategory10, event as d3event } from "d3";

import {
  select as d3Select,
  selectAll as d3SelectAll,
  event as d3event1
} from "d3-selection";
import { line as d3Line } from "d3-shape";

import * as aggregation from "../../aggregation/countAggregation";
import { func, element } from "prop-types";
import { useState } from "react";
import * as interactfuncs from "../../../libtsx/interactfuncs";

import CombinedToolBox from "../../Canvas/CombinedToolBox";

import { histogramBrush } from "../../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../../Brushing/LineChartBrush";
import { parallelCoordinatesPlotBrush } from "../../Brushing/ParallelCoordinatesBrush";
import { barChartBrush } from "../../Brushing/BarChartBrush";

import {clearAllBrushes} from '../../Canvas/MasterGraphConfig'
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from "../../../Globals/ColorConstants"
import { Icon } from "semantic-ui-react";
import {LogEvents} from '../../../Globals/Globals'

import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../../Globals/LogConstants'


interface HistogramStates {}

interface HistogramProps {
  id: string;
  xaxis: string;
  yaxis: string;
  height: number;
  width: number;
}

const Histogram: React.FC<HistogramProps> = ({ id, width, height, xaxis, yaxis }) => {
  const {
    grapVisOptions,
    setgrapVisOptions,
    histogramOptions,
    sethistogramOptions,graphFilter
  } = GraphPredictContext();
 


  console.log('graphFilter',graphFilter)
  var graphDraw = grapVisOptions["graphDraw"];
  var grapCanvasOptions = grapVisOptions["grapCanvasOptions"];
  var grapCanvasClearToggle = grapVisOptions["grapCanvasClearToggle"];
  var graphOptions = grapVisOptions["graphOptions"];
  var graphType = grapVisOptions["graphType"];
  var histogramOptionsBins = histogramOptions["graphBins"];
  var histogramOptionsClear = histogramOptions["graphClear"];
  console.log('dataValuesHistogram',aggregation.loadValues, xaxis, yaxis)
  var dataValues = aggregation.loadValues[xaxis];



  console.log(
    "GraphPredictContextHistogram",
    grapVisOptions,
    histogramOptions,
    histogramOptionsClear,
    dataValues
  );
  

  //var margin = {top: 0.03125*this.props.height, right:  0.09375*this.props.height, bottom: 0.15625*this.props.width, left: 0.125*this.props.width}
  var margin = { top: 10, right: 10, bottom: 60, left: 40 };
  var height = height - margin.left - margin.right;
  var width = width - margin.top - margin.bottom;

  
 

  var domainXMax = d3max(dataValues, function(d) {
    return +d;
  });

  var domainXMin =  Number.parseFloat(d3min(dataValues))

  var linearXScale = d3ScaleLinear()
    .range([0, width])
    .domain([domainXMin, domainXMax]);


  var linearYScale = d3ScaleLinear().range([height, 0]);

  const [min, max] = d3ArrayExtent(dataValues);

  console.log("linearXScale", linearXScale, domainXMax);
  let valueMax = Number(d3max(dataValues));
  let valueMin =  Number(d3min(dataValues));;
  let dom: number[] = linearXScale.domain();
  console.log(valueMax, valueMin, valueMax - valueMin / histogramOptionsBins);
  const thresholds = d3Range(
    valueMin,
    valueMax,
    (valueMax - valueMin) / histogramOptionsBins
  );
  console.log("thresholds", thresholds);
  var datagenerator = histogram<number, number>()
    .value(function(d) {
      return d;
    })
    .domain([dom[0], dom[1]])
    .thresholds(thresholds);

  var ticks = d3.range(linearXScale.domain()[0], linearXScale.domain()[1],  (valueMax - valueMin) / histogramOptionsBins);

  const xAxis = d3AxisBottom(linearXScale);
 

  console.log("graphOptions", graphOptions, linearXScale.domain()[1] + 1);

  let bins = datagenerator(dataValues);
  
  xAxis.tickValues(ticks)
  xAxis.tickFormat(d3.format(".1f"));
  console.log("thresholds", thresholds, bins, );

  var domainYMax = d3max(bins, function(d) {
    return d.length;
  });



  domainYMax =  domainYMax + domainYMax*0.1

  linearYScale.domain([0, domainYMax]);
  var yAxis = d3AxisLeft(linearYScale);
  var rectForeground: any = "";
  console.log("graphDraw", graphDraw, graphOptions);
  var thresholdArrayIds = {};
  var thresholdvaluesMap = {}
  var randomLength = domainYMax*0.1

  for(var i=0;i<thresholds.length;i++)
  {
    if(thresholdvaluesMap[i] == null )
    { 
      if(thresholds[i+1] == undefined)
      {
        thresholdvaluesMap[i] = [thresholds[i].toFixed(1),linearXScale.domain()[1].toFixed(1) + 1]
      }
      else
      {
        thresholdvaluesMap[i] = [thresholds[i].toFixed(1),thresholds[i+1].toFixed(1)]
      }
    }
  }

  if (brushingDataset.getActualID(id) == null) {
    var actualDataset = brushingDataset.addActualID(id);

    actualDataset.setlinearYScale(linearYScale);
    actualDataset.setlinearXScale(linearXScale);
    actualDataset.height = height;
    actualDataset.width = width;
    actualDataset.domainMax = domainYMax
    actualDataset.domainMin = 0;
    actualDataset.xaxis = xaxis;
    actualDataset.yaxis = "Count";
    actualDataset.binsCount = histogramOptionsBins;
    actualDataset.graphOption = graphOptions
    actualDataset.type = HISTOGRAM_CHART;
    actualDataset.thresholds = thresholds;

    actualDataset.yAxis = yAxis;
    actualDataset.xAxis = xAxis;
    actualDataset.randomPredictSize = randomLength;
    var dataValues = aggregation.loadValues1;

    for (let k = 0; k < dataValues.length; k++) {
      var maxvalue = -1;

      for (let l = 0; l < thresholds.length; l++) {
        if (dataValues[k][xaxis] <= thresholds[l]) {
         
          break;
        } else {
          maxvalue = l;
        }
      }
      if (maxvalue != -1) {
       
        if (thresholdArrayIds[maxvalue.toString()] == null) {
          thresholdArrayIds[maxvalue.toString()] = [
            dataValues[k]["ID"].toString()
          ];
        } else {
          thresholdArrayIds[maxvalue.toString()].push(
            dataValues[k]["ID"].toString()
          );
        }
      }
    }
    for(let k=0;k<thresholds.length;k++)
    {
      if(thresholdArrayIds[k.toString()] == undefined)
      {
        thresholdArrayIds[k.toString()]  = []
      }
    }
  
    actualDataset.thresholdArrayIds = thresholdArrayIds;
    console.log('thresholdArrayIdsHistogram',thresholdArrayIds, thresholds)
    actualDataset.thresholdvaluesMap = thresholdvaluesMap;
  } else {
    var actualDataset = brushingDataset.getActualID(id);

    actualDataset.setlinearYScale(linearYScale);
    actualDataset.setlinearXScale(linearXScale);
    actualDataset.height = height;
    actualDataset.width = width;
    actualDataset.domainMax = domainYMax
    actualDataset.domainMin = 0;
    actualDataset.xaxis = xaxis;
    actualDataset.graphOption = graphOptions
    actualDataset.binsCount = histogramOptionsBins;
    actualDataset.yaxis = "Count";
    actualDataset.type = HISTOGRAM_CHART;
    actualDataset.thresholds = thresholds;
    actualDataset.yAxis = yAxis;
    actualDataset.xAxis = xAxis;
    actualDataset.randomPredictSize = randomLength;

    var dataValues = aggregation.loadValues1;
  
    for (let k = 0; k < dataValues.length; k++) {
      var maxvalue = -1;

      for (let l = 0; l < thresholds.length; l++) {
        if (dataValues[k][xaxis] < thresholds[l]) {
        
          break;
        } else {
          maxvalue = l;
        }
      }
      if (maxvalue != -1) {
        if (thresholdArrayIds[maxvalue.toString()] == null) {
          thresholdArrayIds[maxvalue.toString()] = [dataValues[k]["ID"].toString()];
        } else {
          thresholdArrayIds[maxvalue.toString()].push(dataValues[k]["ID"].toString());
        }
      }
    }
    for(let k=0;k<thresholds.length;k++)
    {
      if(thresholdArrayIds[k.toString()] == undefined)
      {
        thresholdArrayIds[k.toString()]  = []
      }
    }
    actualDataset.thresholdArrayIds = thresholdArrayIds;
    console.log('thresholdArrayIdsHistogram',thresholdArrayIds, thresholds)
    actualDataset.thresholdvaluesMap = thresholdvaluesMap;
  }

  var graph: any = "";
  if (graphOptions == '') {
    return (
      <>
        {""}
        <svg
          className={id + "chart"}
          id={id + "_svg_histogram_draw"}
          height={height + margin.left + margin.right}
          width={width + margin.top + margin.bottom}
        >
          <g
            transform={"translate(" + margin.left + ", " + margin.top + ")"}
            id={id + "_svg_histogram"}
          >
            <g transform={"translate(0," + height + ")"}>
              <g
                transform={"translate(0,0)"}
                ref={node => d3Select(node).call(xAxis)} 
              ></g>
            </g>
          
            <g ref={node => d3Select(node).call(yAxis)}></g>
         
          </g>
        </svg>
      </>
    );
  }
  if (graphOptions == PREDICTION) {

   
    

    rectForeground = bins.map(function(d, i) {
      if (
        histogramPredictionDataset.getPredictionID(id + "_predictRect") !=
          null &&
        histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i) != null &&
        histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i).stopy != null
      ) {
        console.log(
          "histogramPredictionDataset histogramPredictionDataset ",
          i,
          " ",
          histogramPredictionDataset
            .getPredictionID(id + "_predictRect")
            .get(id + "_predictRect_" + i)
        );
        histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i)
          .setStopHeight(height);

        var startalterheight = histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i).startheight;
        var startaltery = histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i).starty;
        var length = histogramPredictionDataset
          .getPredictionID(id + "_predictRect")
          .get(id + "_predictRect_" + i).stopy;
        console.log(
          "linearYScale",
          linearYScale(length),
          height - linearYScale(length),
          length,
          height
        );
        return (
          <rect
            id={id + "_predictRect_" + i}
            fill={PREDICTION_COLOR}
            transform={
              "translate(" +
              linearXScale(d.x0) +
              "," +
              linearYScale(length) +
              ")"
            }
            className={id + "_predictRect"}
            width={linearXScale(d.x1) - linearXScale(d.x0) - 1}
            height={height - linearYScale(length)}
          />
        );
      } else {
      

        if (
          histogramPredictionDataset.getPredictionID(id + "_predictRect") ==
          null
        ) {
          var histogramPrediction: HistogramPrediction = new HistogramPrediction();

          histogramPrediction.setStopHeight(height);
          histogramPrediction.setlinearYScale(linearYScale);
          histogramPrediction.setlinearXScale(linearXScale);
          histogramPredictionDataset
            .addPredictionID(id + "_predictRect")
            .set(id + "_predictRect_" + i, histogramPrediction);
          histogramPredictionDataset.addInitial(id + "_predictRect");
      
        } else {
          if (
            histogramPredictionDataset
              .getPredictionID(id + "_predictRect")
              .get(id + "_predictRect_" + i) != null
          ) {
            histogramPrediction = histogramPredictionDataset
              .getPredictionID(id + "_predictRect")
              .get(id + "_predictRect_" + i);
            histogramPrediction.setStopHeight(height);
            histogramPrediction.setlinearYScale(linearYScale);
            histogramPrediction.setlinearXScale(linearXScale);
          } else {
            var histogramPrediction: HistogramPrediction = new HistogramPrediction();
            histogramPrediction.setStopHeight(height);
            histogramPrediction.setlinearYScale(linearYScale);
            histogramPrediction.setlinearXScale(linearXScale);
            histogramPredictionDataset
              .getPredictionID(id + "_predictRect")
              .set(id + "_predictRect_" + i, histogramPrediction);
          }
        }
        console.log('histogramPredictionDataset.getnull',histogramPredictionDataset.getPredictionID(id + "_predictRect"))

        return (
          <rect
            id={id + "_predictRect_" + i}
            fill={PREDICTION_COLOR}
            transform={
              "translate(" +
              linearXScale(d.x0) +
              "," +
              linearYScale(randomLength) +
              ")"
            }
            className={id + "_predictRect"}
            width={linearXScale(d.x1) - linearXScale(d.x0) - 1}
            height={height - linearYScale(randomLength)}
          />
        );
      }
    });
    console.log("histogramPredictionDatasetUU", histogramPredictionDataset);
    console.log("rectForeground", rectForeground);

    React.useEffect(() => {
      console.log("useEffect");
      console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);

      if (
        graphOptions == PREDICTION &&
        document.getElementById(id + "_svg_histogram_draw")
      ) {
        interactfuncs.resizeTopRect(
          id + "_predictRect",
          xaxis,
          "Count",
          graphType
        );
       
       
      }
      if (
        graphOptions == SEEDATA 
      )
      {


      }


     
    }, [graphType,graphOptions]);


    
    return (
      <>
        {""}
        <svg
          className={id + "chart"}
          id={id + "_svg_histogram_draw"}
          height={height + margin.left + margin.right}
          width={width + margin.top + margin.bottom}
        >
          <g
            transform={"translate(" + margin.left + ", " + margin.top + ")"}
            id={id + "_svg_histogram"}
          >
            <g transform={"translate(0," + height + ")"}>
              <g
                transform={"translate(0,0)"}
                ref={node => d3Select(node).call(xAxis)} 
              ></g>
            </g>
          
            <g ref={node => d3Select(node).call(yAxis)}></g>
            {rectForeground}
          </g>
        </svg>
      </>
    );
  }

  if (graphOptions == SEEDATA) {

  

    var histogrampredictionInital = histogramPredictionDataset.getInitial(
      id + "_predictRect"
    );
      
    console.log("histogramprediction SEEDATA", histogrampredictionInital);
   
    if (histogrampredictionInital == true) {
      var groupBins = bins.map(function(d, i) {
        var histogramprediction = histogramPredictionDataset.getPredictionID(
          id + "_predictRect"
        );
        var name 
        if(i==bins.length-1)
        {
            name = thresholds[i].toFixed(1)+"-"+domainXMax
        }
        else
        {
          name = thresholds[i].toFixed(1)+"-"+thresholds[i+1].toFixed(1)
        }
       
    

        if (
          histogramprediction != null &&
          histogramprediction.get(id + "_predictRect_" + i) != null &&
          histogramprediction.get(id + "_predictRect_" + i).stopy != null
        ) {
          var predictionlength = histogramPredictionDataset
            .getPredictionID(id + "_predictRect")
            .get(id + "_predictRect_" + i).stopy;
       
          return {
            name: name,
            actual: d.length,
            prediction: predictionlength,
            predicted: true
          };
        } else {
          return {
            name: name,
            actual: d.length,
            prediction: randomLength,
            predicted: false
          };
        }
      });

      console.log("groupBins", groupBins);
      var barPadding = 0.2;
      var axisTicks = { qty: 5, outerSize: 0, dateFormat: "%m-%d" };

      var xScale0 = d3
        .scaleBand()
        .rangeRound([0, width])
        .paddingInner(barPadding);
      var xScale1 = d3.scaleBand().padding(0.05);;

      var yScale = d3.scaleLinear().rangeRound([height, 0]);
      var xAxis_combined = d3
        .axisBottom(xScale0)
        .tickSizeOuter(axisTicks.outerSize);

      xScale0.domain(groupBins.map(d => d.name));
      xScale1.domain(["actual", "prediction"]).rangeRound([0, xScale0.bandwidth()]);
      var d3maxPredict = d3.max(groupBins.map(d=>d.prediction))
      var d3maxActual = d3.max(groupBins.map(d=>d.actual))
      yScale.domain([
        0,
        d3.max([d3maxPredict,d3maxActual])
      ]);
      
     yAxis = d3AxisLeft(yScale) 
     
      var rectBackground = groupBins.map(function(d, i) {
        if (d.predicted == true) {
          return (
            <>
              <g transform={"translate(" + xScale0(d.name) + ",0)"}>
                <rect
                  fill={REALDATA_COLOR}
                  x={xScale1("actual")}
                  y={yScale(d.actual)}
                  className={
                    id +
                    "_svg_histogram_draw_g_rect Histogram_" +
                    xaxis +
                    "_" +
                    i +
                    "_" +
                    id +
                    " "
                  }
                  width={xScale1.bandwidth()}
                  height={height - yScale(d.actual)}
                  onClick={function(dc) {

                    if(BrushingDataSet.currentGraphID!=id)
                    {
                    clearAllBrushes()
                    }
                    var brushingPointsHistogramMap= brushingDataset.getBrushingHistogramMap();
                      
                    var target = dc.currentTarget
                    console.log("target.classList",target.classList)
                    if (target.classList.contains('brushon')) {
                        target.classList.remove('brushon')
                        target.setAttribute('style', "fill:" + REALDATA_COLOR)
                        var rangeHis = d.name.split("-")
                        var start = parseFloat(rangeHis[0]),
                        end = parseFloat(rangeHis[1]);
                       
                        brushingPointsHistogramMap.delete(d.name)
                     
                        if (brushingPointsHistogramMap.size == 0) {

                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                          if(logevents)
                          {
                              var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                              logevents._logEvents.push(event)
                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                          }

                          BrushingDataSet.currentGraphID = id
                          BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                          BrushingDataSet.currentGraphData = Array.from(brushingPointsHistogramMap.values())
                          BrushingDataSet.currentGraphEnable = 2
                          histogramBrush(2,id, "none", brushingDataset);

                        }
                        else {


                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                          if(logevents)
                          {
                              var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                              logevents._logEvents.push(event)
                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                          }

                          BrushingDataSet.currentGraphID = id
                          BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                          BrushingDataSet.currentGraphData = Array.from(brushingPointsHistogramMap.values())
                          BrushingDataSet.currentGraphEnable = 0
                          histogramBrush(0, id, Array.from(brushingPointsHistogramMap.values()), brushingDataset);

                        }


                    }
                    else {
                        target.classList.add('brushon')
                        var rangeHis = d.name.split("-")
                        var start = parseFloat(rangeHis[0]),
                          end = parseFloat(rangeHis[1]);
                          console.log('start',start,end)
                        brushingDataset.getBrushingHistogramAxis().xaxis = xaxis;
                        brushingDataset.getBrushingHistogramAxis().yaxis = "Count";
                       
                        var brushingPointsHistogram = new BrushingPointsHistogram();
                        brushingPointsHistogram.startX = start;
                        brushingPointsHistogram.endX = end;
                        brushingPointsHistogram.type = PREDICTION
                        brushingPointsHistogram.thresholdArrayIds = brushingDataset.getActualID(id).thresholdArrayIds;
                        brushingPointsHistogram.thresholds = thresholds;

                        brushingPointsHistogramMap.set(d.name,brushingPointsHistogram)

                        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                          if(logevents)
                          {
                              var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                              logevents._logEvents.push(event)
                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                          }

                        BrushingDataSet.currentGraphID = id
                        BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                        BrushingDataSet.currentGraphData = Array.from(brushingPointsHistogramMap.values())
                        BrushingDataSet.currentGraphEnable = 0
                        histogramBrush(0, id, Array.from(brushingPointsHistogramMap.values()), brushingDataset);

                        target.setAttribute('style', "fill:" + BRUSHING_COLOR)
                       

                    }


                }}
                ></rect>
                <rect
                  fill={PREDICTION_COLOR}
                  x={xScale1("prediction")}
                  y={yScale(d.prediction)}
                  width={xScale1.bandwidth()}
                  height={height - yScale(d.prediction)}
                ></rect>
              </g>
            </>
          );
        } else {
          return (
            <>
              <g transform={"translate(" + xScale0(d.name) + ",0)"}>
                <rect
                  fill={REALDATA_COLOR}
                  x={xScale1("actual")}
                  y={yScale(d.actual)}
                  width={xScale1.bandwidth()}
                  height={height - yScale(d.actual)}
                  className={
                    id +
                    "_svg_histogram_draw_g_rect Histogram_" +
                    xaxis +
                    "_" +
                    i +
                    "_" +
                    id +
                    " "
                  }
                  onClick={function(dc) {

                    if(BrushingDataSet.currentGraphID!=id)
                    {
                    clearAllBrushes()
                    }
                
                    var brushingPointsHistogramMap = brushingDataset.getBrushingHistogramMap();
                    var target = dc.currentTarget
                    console.log("target.classList",target.classList)
                    if (target.classList.contains('brushon')) {
                        target.classList.remove('brushon')
                        target.setAttribute('style', "fill:" + REALDATA_COLOR)
                        var rangeHis = d.name.split("-")
                        var start = parseFloat(rangeHis[0]),
                        end = parseFloat(rangeHis[1]);
                       
                        brushingPointsHistogramMap.delete(d.name)
                      
                        if (brushingPointsHistogramMap.size == 0) {

                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                          if(logevents)
                          {
                              var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                              logevents._logEvents.push(event)
                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                          }

                          
                          BrushingDataSet.currentGraphID = id
                          BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                          BrushingDataSet.currentGraphData = "none"
                          BrushingDataSet.currentGraphEnable = 2
                          histogramBrush(2,id, "none", brushingDataset);

                        }
                        else {

                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                          if(logevents)
                          {
                              var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                              logevents._logEvents.push(event)
                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                          }

                          BrushingDataSet.currentGraphID = id
                          BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                          BrushingDataSet.currentGraphData = Array.from(brushingPointsHistogramMap.values())
                          BrushingDataSet.currentGraphEnable = 0
                          histogramBrush(0, id, Array.from(brushingPointsHistogramMap.values()), brushingDataset);

                        }


                    }
                    else {
                        target.classList.add('brushon')
                        var rangeHis = d.name.split("-")
                        var start = parseFloat(rangeHis[0]),
                          end = parseFloat(rangeHis[1]);
                          console.log('start',start,end)
                        brushingDataset.getBrushingHistogramAxis().xaxis = xaxis;
                        brushingDataset.getBrushingHistogramAxis().yaxis = "Count";
                       
                        var brushingPointsHistogram = new BrushingPointsHistogram();
                        brushingPointsHistogram.startX = start;
                        brushingPointsHistogram.endX = end;
                        brushingPointsHistogram.type = PREDICTION
                        brushingPointsHistogram.thresholdArrayIds = brushingDataset.getActualID(id).thresholdArrayIds;
                        brushingPointsHistogram.thresholds = thresholds;
                        brushingPointsHistogramMap.set(d.name, brushingPointsHistogram)
                      
                        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                        if(logevents)
                        {
                            var event = LogEvents.addEvent(id, HISTOGRAM_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, SEEDATA, null, brushingPointsHistogramMap,xaxis,yaxis,null)
                            logevents._logEvents.push(event)
                            sessionStorage.setItem('logevents', JSON.stringify(logevents))
                        }

                        BrushingDataSet.currentGraphID = id
                        BrushingDataSet.currentGraphType = HISTOGRAM_CHART
                        BrushingDataSet.currentGraphData = Array.from(brushingPointsHistogramMap.values())
                        BrushingDataSet.currentGraphEnable = 0
                        histogramBrush(0, id, Array.from(brushingPointsHistogramMap.values()), brushingDataset);

                        target.setAttribute('style', "fill:" + BRUSHING_COLOR)
                       

                    }


                }}
                ></rect>
                <rect
                  fill={NO_PREDICTION_COLOR}
                  x={xScale1("prediction")}
                  y={yScale(d.prediction)}
                  width={xScale1.bandwidth()}
                  height={height - yScale(d.prediction)}
                ></rect>
              </g>
            </>
          );
        }
      });
      var brushX = brushHistogramX(height, width, id, xaxis, bins, linearXScale, thresholds, yaxis)

      brushingDataset.getActualID(id).brush = brushX
      
      React.useEffect(() => {
        console.log("useEffectBarChart");
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
        console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);

      

        if (
            graphOptions == SEEDATA 
          )
          {
                
              if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
              {
                
                histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
              {
                
                scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == BAR_CHART)
              {
                console.log('BrushingDataSet.currentGraphData',BrushingDataSet.currentGraphData)
                barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == LINE_CHART)
              {
                
                lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
              {
                
                parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
              }
              
            
          }
    }, [graphType, graphOptions, width, height]);

      return (
        <>
          <svg
            className={id + "chart"}
            id={id + "_svg_histogram_draw"}
            height={height + margin.left + margin.right}
            width={width + margin.top + margin.bottom}
          >
            <g
              transform={"translate(" + margin.left + ", " + margin.top + ")"}
              id={id + "_svg_histogram"}
            >
              <g
                transform={"translate(0," + height + ")"}
                ref={node => d3Select(node).call(xAxis_combined)}
              ></g>
              <g ref={node => d3Select(node).call(yAxis)}>{rectBackground}</g>
            </g>
          </svg>
        </>
      );
    } else {
      
      rectForeground = bins.map(function(d, i) {
        console.log(
          "ACTUAL",
          d.length,
          i,
          d.x0,
          linearXScale(d.x0),
          linearXScale.invert(d.x0),
          linearYScale.invert(linearYScale(d.length)),
          linearYScale(d.length)
        );
        return (
          <rect
            fill={REALDATA_COLOR}
            transform={
              "translate(" +
              linearXScale(d.x0) +
              "," +
              linearYScale(d.length) +
              ")"
            }
            width={linearXScale(d.x1) - linearXScale(d.x0) - 1}
            height={height - linearYScale(d.length)}
            className={
              id +
              "_svg_histogram_draw_g_rect Histogram_" +
              xaxis +
              "_" +
              i +
              "_" +
              id +
              " "
            }
          />
        );
      });

      var brushX = brushHistogramX(height, width, id, xaxis, bins, linearXScale, thresholds, yaxis)

      brushingDataset.getActualID(id).brush = brushX

      React.useEffect(() => {
        console.log("useEffectBarChart");
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
        console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);

      

        if (
            graphOptions == SEEDATA 
          )
          {
                
              if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
              {
                
                histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
              {
                
                scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == BAR_CHART)
              {
                console.log('BrushingDataSet.currentGraphData',BrushingDataSet.currentGraphData)
                barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }

              if(BrushingDataSet.currentGraphType == LINE_CHART)
              {
                
                lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
              {
                
                parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
              }
              
            
          }
    }, [graphType, graphOptions, width, height]);

      return (
        <>
          <svg
            className={id + "chart"}
            id={id + "_svg_histogram_draw"}
            height={height + margin.left + margin.right}
            width={width + margin.top + margin.bottom}
          >
            <g
              transform={"translate(" + margin.left + ", " + margin.top + ")"}
              id={id + "_svg_histogram"}
              className={id}
            >
              <g   transform={"translate(0," + height + ")"}> 
              <g id={id+"brushX"}
              
                ref={node => d3Select(node).call(brushX)
                     }
              >
                <g
                  transform={"translate(0,0)"}
                  ref={node => d3Select(node).call(xAxis) } 
                ></g>
              </g>
              </g>
              <g ref={node => d3Select(node).call(yAxis)}></g>

              {rectForeground}
            </g>
          </svg>
        </>
      );
    }
  }
  console.log(id, "here");

  console.log("rectForeground", rectForeground);
};
export default Histogram;

export function brushHistogramX(height, width, id, xaxis, bins, linearXScale, thresholds, yaxis){
    var brushX = d3
    .brushX()
    
    .extent([[0, -height], [width, 16]])
    .on("start", function(e){
     
      var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
      if(logevents)
        {
         var eventlog = LogEvents.addEvent(id, HISTOGRAM_CHART, SEEDATA, LOG_EVENT_TYPE_CHART_BRUSHING_STARTED,null, null,xaxis,yaxis,null)
      logevents._logEvents.push(eventlog)
      sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

      if(BrushingDataSet.currentGraphID!=id)
        {
        clearAllBrushes()
        }
     
      }
     )
   
    .on("brush", function(d, i, j) {
     
      var brush_coords = d3brushSelection(this);
    
      if (brush_coords != null) {
        var x0 = brush_coords[0];
        var x1 = brush_coords[1];

        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = HISTOGRAM_CHART
        BrushingDataSet.currentGraphData = "none"
        BrushingDataSet.currentGraphEnable = 2
        BrushingDataSet.currentGraphBrushInstance = brushX

        histogramBrush(2, id, "none", brushingDataset);
        var start = 0,
          end = 0;
        brushingDataset.getBrushingHistogramAxis().xaxis = xaxis;
        brushingDataset.getBrushingHistogramAxis().yaxis = "Count";
     /*   bins.map(function(d, i) {
          if (x0 >= linearXScale(d.x0) && x0 <= linearXScale(d.x1)) {
            start = d.x0;
          }
          if (x1 >= linearXScale(d.x0) && x1 <= linearXScale(d.x1)) {
            end = d.x1;
          }
        });*/
        start = linearXScale.invert(x0) 
        end = linearXScale.invert(x1)
        brushingDataset.emptyBrushingHistogramArray();
        var brushingPointsHistogramArray = brushingDataset.getBrushingHistogramArray();
        var brushingPointsHistogram = new BrushingPointsHistogram();
        brushingPointsHistogram.startX = start;
        brushingPointsHistogram.endX = end;
        console.log('thresholdArrayIdsthresholdArrayIds',brushingDataset.getActualID(id).thresholdArrayIds)
        brushingPointsHistogram.thresholdArrayIds = brushingDataset.getActualID(id).thresholdArrayIds;
        brushingPointsHistogram.thresholds = thresholds;
  
        brushingPointsHistogramArray.push(brushingPointsHistogram);

        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = HISTOGRAM_CHART
        BrushingDataSet.currentGraphData = brushingPointsHistogramArray
        BrushingDataSet.currentGraphEnable = 0
        BrushingDataSet.currentGraphBrushInstance = brushX

        histogramBrush(0, id, brushingPointsHistogramArray, brushingDataset);
      }
      else{
        console.log("mouseHis", brush_coords)
      }
      
    })
    .on("end", function() {
      
     

      var brush_coords = d3brushSelection(this);
      if (brush_coords == null) {

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
          {
           var eventlog = LogEvents.addEvent(id, HISTOGRAM_CHART, SEEDATA, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED,null, brush_coords,xaxis,yaxis,null)
          logevents._logEvents.push(eventlog)
          sessionStorage.setItem('logevents', JSON.stringify(logevents))
          }

        brushingDataset.emptyBrushingHistogramArray();

        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = HISTOGRAM_CHART
        BrushingDataSet.currentGraphData = "none"
        BrushingDataSet.currentGraphEnable = 2
        BrushingDataSet.currentGraphBrushInstance = brushX

        histogramBrush(2,id, "none", brushingDataset);
      }

     

    });
    return brushX
}

function beforebrushstarted(X, brush) {
  const dx = X(1) - X(0); // Use a fixed width when recentering.
  const [cx] = d3.mouse(this);
  const [x0, x1] = [cx - dx / 2, cx + dx / 2];
  const [X0, X1] = X.range();
  d3.select(this.parentNode)
      .call(brush.move, x1 > X1 ? [X1 - dx, X1] 
          : x0 < X0 ? [X0, X0 + dx] 
          : [x0, x1]);
}


function isBrushed(brush_coords, cx, cy) {
  var x0 = brush_coords[0][0],
    x1 = brush_coords[1][0],
    y0 = brush_coords[0][1],
    y1 = brush_coords[1][1];
  return x0 <= cx && cx <= x1 && y0 <= cy && cy <= y1;
}
